// [VexFlow](https://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
// MIT License

import { GonvilleFont } from './gonville_glyphs';
import { GonvilleMetrics } from './gonville_metrics';

export const Gonville = {
  data: GonvilleFont,
  metrics: GonvilleMetrics,
};
